import React, { useState, useRef, useEffect } from "react";

function OccupationDropdown({ value, onChange, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  const dropdownRef = useRef(null);

  const data = [
    {
      category: { id: 1, name: "ADMINISTRATION" },
      options: [
        { id: 1, name: "Manager" },
        { id: 2, name: "Supervisor " },
        { id: 3, name: "Officer " },
        { id: 4, name: "Administrative Professinal" },
        { id: 5, name: "Executive" },
        { id: 6, name: "Clerk" },
        { id: 7, name: "Human Resource Professional" },
        { id: 8, name: "Secretary/Front Office" },
      ],
    },
    {
      category: { id: 2, name: "AGRICULTURE" },
      options: [
        { id: 9, name: "Agriculture & Farming Professional" },
        { id: 10, name: "Horticulturist" },
      ],
    },
    {
      category: { id: 3, name: "AIRLINE" },
      options: [
        { id: 11, name: "Pilot" },
        { id: 12, name: "Air Hostess/Flight Attendant" },
        { id: 13, name: "Airline Professional" }
      ],
    },
    {
      category: { id: 4, name: "ARCHITECTURE & DESIGN" },
      options: [
        { id: 14, name: "Architect" },
        { id: 15, name: "Interior Design" }

      ],
    },
    {
      category: { id: 5, name: "BANKING & FINANCE" },
      options: [
        { id: 16, name: "Chatered Accountant" },
        { id: 17, name: "Company Secretary" },
        { id: 18, name: "Accounts/Finance Professional" },
        { id: 19, name: "Banking Profesional" },
        { id: 20, name: "Auditor" },
        { id: 21, name: "Financial Accountant" },
        { id: 22, name: "Financial Analyst/Planing" },
        { id: 23, name: "Investment Professional" },

      ],
    },
    {
      category: { id: 6, name: "BEAUTY & FASHION" },
      options: [
        { id: 24, name: "Fashion Designer" },
        { id: 25, name: "Beautician" },
        { id: 26, name: "Hair Stylist" },
        { id: 27, name: "Jewellery Designer" },
        { id: 28, name: "Designer(Others)" },
        { id: 29, name: "Makeup Artist" },

      ],
    },
    {
      category: { id: 7, name: "BPO & CUSTOMER SERVICE" },
      options: [
        { id: 30, name: "BPO/KPO/ITES Professional" },
        { id: 31, name: "Customer Service Professional" }
      ],
    },
    {
      category: { id: 8, name: "CIVIL SERVICE" },
      options: [
        { id: 32, name: "Civil Services(IAS/IPS/IRS/IES/IFS)" }
      ],
    },
    {
      category: { id: 9, name: "CORPORATE PROFESSIONALS" },
      options: [
        { id: 33, name: "Analyst" },
        { id: 34, name: "Consultant" },
        { id: 35, name: "Corporate Communication" },
        { id: 36, name: "Corporate Planning" },
        { id: 37, name: "Marketing Professional" },
        { id: 38, name: "Operation Managment" },
        { id: 39, name: "Sales Professional" },
        { id: 40, name: "Senior Manager/Manager" },
        { id: 41, name: "Subject Matter Expert" },
        { id: 42, name: "Business Development Professional" },
        { id: 43, name: "Content Writer" }
      ],
    },
    {
      category: { id: 10, name: "DEFENCE" },
      options: [
        { id: 44, name: "Army" },
        { id: 45, name: "Navy" },
        { id: 46, name: "Defence Service(Others)" },
        { id: 47, name: "Air Force" },
        { id: 48, name: "Paramilitary" }
      ],
    },
    {
      category: { id: 11, name: "DOCTORE" },
      options: [
        { id: 49, name: "Doctor" },
        { id: 50, name: "Dentist" },
        { id: 51, name: "Surgeon" },
        { id: 52, name: "Veterinary Doctor" }
      ],
    },
    {
      category: { id: 12, name: "EDUCATION & TRAINING" },
      options: [
        { id: 53, name: "Professor/Lecturer" },
        { id: 54, name: "Teaching/Academician" },
        { id: 55, name: "Education Professional" },
        { id: 56, name: "Training Professional" },
        { id: 57, name: "Research Assistant" },
        { id: 58, name: "Research Scholar" }
      ],
    },
    {
      category: { id: 13, name: "ENGINEERING" },
      options: [
        { id: 59, name: "Civil Engineer" },
        { id: 60, name: "Electronics/Telecom Engineer" },
        { id: 61, name: "Mechanical/Production Engineer" },
        { id: 62, name: "Quality Assurance Engineer/ Non IT" },
        { id: 63, name: "Engineer-Non IT" },
        { id: 64, name: "Designer" },
        { id: 65, name: "Product Manager-Non IT" },
        { id: 66, name: "Project Manager-Non IT" }
      ],
    },
    {
      category: { id: 14, name: "HOSPITALITY" },
      options: [
        { id: 67, name: "Hotel/Hospitality Professional" },
        { id: 68, name: "Restaurant/Catering Professional" },
        { id: 69, name: "Chef/Cook" }
      ],
    },
    {
      category: { id: 15, name: "IT & SOFTWARE" },
      options: [
        { id: 70, name: "Software Professional" },
        { id: 71, name: "Hardware Professional" },
        { id: 72, name: "Product Manager" },
        { id: 73, name: "Project Manager" },
        { id: 74, name: "Program Manager" },
        { id: 75, name: "Animator" },
        { id: 76, name: "Cyber/Network Security" },
        { id: 77, name: "UI/UX Designer" },
        { id: 78, name: "Web/Graphic Designer" },
        { id: 79, name: "Software Consultant" },
        { id: 80, name: "Data Analyst" },
        { id: 81, name: "Data Scientist" },
        { id: 82, name: "Network Engineer" },
        { id: 83, name: "Quality Assurance Engineer" }
      ],
    },
    {
      category: { id: 16, name: "LEGAL" },
      options: [
        { id: 84, name: "Lawyer & Legal Professional" },
        { id: 85, name: "Legal Assistant" }

      ],
    },
    {
      category: { id: 17, name: "MEDIA & ENTERTAINMENT" },
      options: [
        { id: 86, name: "Journalist" },
        { id: 87, name: "Media Professional" },
        { id: 88, name: "Entertainment Professional" },
        { id: 89, name: "Event Management Professional" },
        { id: 90, name: "Advertising/PR Professional" },
        { id: 91, name: "Designer" },
        { id: 92, name: "Actor/Model" },
        { id: 93, name: "Artist" }
      ],
    },
    {
      category: { id: 18, name: "MEDICAL & HEALTHCARE - OTHER" },
      options: [
        { id: 94, name: "Healthcare Professional" },
        { id: 95, name: "Paramedical Professional" },
        { id: 96, name: "Nurse" },
        { id: 97, name: "Pharmacist" },
        { id: 98, name: "Physiotherapist" },
        { id: 99, name: "Psychologist" },
        { id: 100, name: "Therapist" },
        { id: 101, name: "Medical Transcriptionist" },
        { id: 102, name: "Dietician/Nutritionist" },
        { id: 103, name: "Lab Technician" },
        { id: 104, name: "Medical Representative" }
      ],
    },
    {
      category: { id: 19, name: "MERCHANT NAVY" },
      options: [
        { id: 105, name: "Marnier/Marchant Navy" },
        { id: 106, name: "Sailor" }
      ],
    },
    {
      category: { id: 20, name: "OTHERS" },
      options: [
        { id: 107, name: "Technician" },
        { id: 108, name: "Arts&Craftsman" },
        { id: 109, name: "Librarian" },
        { id: 110, name: "Business Owner/Entrepreneur" },
        { id: 111, name: "Transportation/Logistics Professional" },
        { id: 112, name: "Agent/Broker/Trader" },
        { id: 113, name: "Contractor" },
        { id: 114, name: "Fitness Professional" },
        { id: 115, name: "Security Professional" },
        { id: 116, name: "Social Worker/Voluteer/NGO" },
        { id: 117, name: "Sportsperson" },
        { id: 118, name: "Travel Professional" },
        { id: 119, name: "Singer" },
        { id: 120, name: "Writer" },
        { id: 121, name: "Politician" },
        { id: 122, name: "Associate" },
        { id: 123, name: "Builder" },
        { id: 124, name: "Chemist" },
        { id: 125, name: "CNC Operator" },
        { id: 126, name: "Distributor" },
        { id: 127, name: "Driver" },
        { id: 128, name: "Freelancer" },
        { id: 129, name: "Mechanic" },
        { id: 130, name: "Musician" },
        { id: 131, name: "Photo/Videographer" },
        { id: 132, name: "Suveyor" },
        { id: 133, name: "Tailor" },
        { id: 134, name: "Others" }
      ],
    },
    {
      category: { id: 21, name: " POLICE/LAW ENFORCEMENT" },
      options: [
        { id: 135, name: "Law Enforcement Officer" },
        { id: 136, name: "Police" }
      ],
    },
    {
      category: { id: 22, name: "SCIENTIST" },
      options: [
        { id: 137, name: "Scientist/Researcher" }
      ],
    },
    {
      category: { id: 23, name: "SENIOR MANAGEMENT" },
      options: [
        { id: 138, name: "CXO/President,Director,Chairmant" },
        { id: 139, name: "VP/AVP/GM/DGM/AGM" }
      ],
    },

    {
      category: { id: 24, name: "Not Working" },
      options: [
        { id: 140, name: "Not Working" },

      ],
    }
  ];

  // ✅ Filter based on search (now option is an object)
  const filteredData = data.map((section) => ({
    ...section,
    options: section.options.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    ),
  }));
  useEffect(() => {
    if (value) {
      for (let section of data) {
        const match = section.options.find(opt => opt.id === value);
        if (match) {
          setSelected(match.name);
          break;
        }
      }
    }
  }, [value]);
  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelected(option.name);
    setIsOpen(false);
    setSearch("");
    onChange(option.id)
  };

  const disableRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <div className="w-100 " style={styles.container} ref={dropdownRef} onContextMenu={disableRightClick}>
      {/* Closed state */}
      <div
        className="form-control fs-6"
        style={{
          ...styles.dropdownHeader,
          backgroundColor: disabled ? "#e9ecef" : "#fff",
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? "#6c757d" : "#212529",
        }}
        onClick={() => {
          if (!disabled) {
            setIsOpen(!isOpen);
          }
        }}
      >
        {selected || "Select Occupation"}

        {!disabled && (
          <span style={styles.arrow}>
            {isOpen ? "▲" : "▼"}
          </span>
        )}
      </div>
      {/* Expanded state */}
      {isOpen && (
        <div style={styles.dropdownList}>
          <input
            className="w-100 "
            type="text"
            placeholder="Select your Occupation. "
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.searchBox}
            autoFocus
          />

          <div style={styles.scrollArea}>
            {filteredData.map((section) => (
              <div key={section.category.id}>
                <div style={styles.category}>-- {section.category.name} --</div>
                {section.options.length > 0 ? (
                  section.options.map((option) => (
                    <div
                      key={option.id}
                      style={styles.option}
                      onClick={() => handleSelect(option)}
                    >
                      {option.name}
                    </div>
                  ))
                ) : (
                  <div style={styles.noMatch}>No matches found</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}

const styles = {
  container: {
    width: 400,
    marginTop: 20,
    position: "relative",
    fontFamily: "Arial, sans-serif",
  },
  dropdownHeader: {
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "13px"
  },
  arrow: {
    fontSize: 12,
    color: "#555",
  },
  dropdownList: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: 4,
    marginTop: 2,
    zIndex: 100,
  },
  searchBox: {
    width: "100%",
    padding: "8px 10px",
    border: "none",
    borderBottom: "1px solid #eee",
    outline: "none",
  },
  scrollArea: {
    maxHeight: 180,
    overflowY: "auto",
  },
  category: {
    fontWeight: "bold",
    fontSize: 14,
    color: "#888",
    padding: "6px 10px",
  },
  option: {
    padding: "6px 12px",
    cursor: "pointer",
  },
  noMatch: {
    padding: "6px 12px",
    color: "#999",
    fontStyle: "italic",
  },
};

export default OccupationDropdown;
